import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {window} from 'ssr-window';
import IconFilter from '@spothero/icons/filter';
import IconTicket from '@spothero/icons/ticket';
import Badge from '@spothero/ui/badge';
import Button from '@spothero/ui/button';
import Select from '@spothero/ui/select';
import DOMUtils from '@spothero/utils/dom';
import {DESTINATION_DATA} from 'destination/destination-prop-types';
import EventListItem from 'event/EventListItem';
import {
    setSortType,
    toggleFiltersView,
    toggleInfoPanelView,
} from '../search-actions';
import SearchBreadcrumbsDesktop from '../breadcrumbs/SearchBreadcrumbsDesktop';
import SingleTermSearchControls from './SingleTermSearchControls';
import SearchTermToggle from './SearchTermToggle';
import SearchControlsHeading from './SearchControlsHeading';

class SpotListSearchControls extends Component {
    static propTypes = {
        isFetchComplete: PropTypes.bool.isRequired,
        city: PropTypes.object.isRequired,
        destination: PropTypes.shape(DESTINATION_DATA).isRequired,
        event: PropTypes.object,
        numSpots: PropTypes.number.isRequired,
        searchType: PropTypes.string.isRequired,
        showEventList: PropTypes.bool,
        breadcrumbs: PropTypes.object,
        numActiveFilters: PropTypes.number.isRequired,
        areFiltersVisible: PropTypes.bool,
        sortBy: PropTypes.string,
        onToggleInfoPanel: PropTypes.func.isRequired,
        onFilterSpotsToggle: PropTypes.func.isRequired,
        onChangeSort: PropTypes.func.isRequired,
        onToggleEventList: PropTypes.func,
    };
    state = {
        areControlsShowing: false,
    };

    constructor(props) {
        super(props);

        this._hasSmallWindow = window.innerWidth < 900; // uses breakpoint-md value of 900
        this._sortSelectItems = [
            {value: 'distance', label: 'Sort by Distance'},
            {value: 'price', label: 'Sort by Price'},
        ];
    }

    componentDidMount() {
        if (this._hasSmallWindow) {
            this.props.onToggleInfoPanel(false);
        }
    }

    _onActionsToggle = isShowing => {
        this.setState({
            areControlsShowing: isShowing,
        });
    };

    _onSelectChange = ({value}) => {
        this.props.onChangeSort(value);
    };

    _onFilterSpotsToggle = () => {
        const {
            showEventList,
            onFilterSpotsToggle,
            onToggleEventList,
        } = this.props;

        onFilterSpotsToggle();

        if (showEventList) {
            onToggleEventList();
        }
    };

    _onToggleEventList = () => {
        const {
            areFiltersVisible,
            onFilterSpotsToggle,
            onToggleEventList,
        } = this.props;

        onToggleEventList();

        if (areFiltersVisible) {
            onFilterSpotsToggle();
        }
    };

    _onShowInfoClick = () => {
        const {onToggleInfoPanel} = this.props;

        if (this._hasSmallWindow) {
            const pageContainer = DOMUtils.el('.search-page');

            DOMUtils.addClass(pageContainer, 'info-panel-hidden');
        }

        onToggleInfoPanel(true);
    };

    render() {
        const {
            isFetchComplete,
            city,
            destination,
            event,
            numSpots,
            breadcrumbs,
            sortBy,
            numActiveFilters,
            showEventList,
            searchType,
        } = this.props;
        const {areControlsShowing} = this.state;
        const badgeLabel =
            numActiveFilters > 0 ? numActiveFilters.toString() : null;
        const hasEvents = Boolean(
            destination.has_upcoming_events &&
                destination.events &&
                destination.events.length > 0
        );

        return (
            <div className="SpotListSearchControls">
                <div className="SpotListSearchControls-info">
                    {searchType !== 'event' && <SearchTermToggle />}
                    {searchType !== 'city' && (
                        <SearchBreadcrumbsDesktop data={breadcrumbs} />
                    )}
                </div>
                {searchType !== 'address' && searchType !== 'event' && (
                    <SearchControlsHeading
                        onShowInfoClick={this._onShowInfoClick}
                    />
                )}
                {searchType === 'event' && (
                    <EventListItem
                        city={city}
                        destination={destination}
                        event={event}
                        isMobile={false}
                        showFindParking={false}
                        showVenue
                        showYear
                        isPolishTimepickersEnabled
                        onShowInfoClick={this._onShowInfoClick}
                    />
                )}
                <SingleTermSearchControls
                    showSearchBar={searchType !== 'event'}
                    showHeader={false}
                    onActionsToggle={this._onActionsToggle}
                />
                {((isFetchComplete && numSpots > 0) || !isFetchComplete) &&
                    !areControlsShowing && (
                        <div className="SpotListSearchControls-actions">
                            {hasEvents && !showEventList && (
                                <Button
                                    className="SpotListSearchControls-actions-cta SpotListSearchControls-events"
                                    onClick={this._onToggleEventList}
                                >
                                    View Upcoming Events <IconTicket />
                                </Button>
                            )}
                            <div className="SpotListSearchControls-actions-right">
                                <Select
                                    className="SpotListSearchControls-sort"
                                    defaultValue={sortBy}
                                    onChange={this._onSelectChange}
                                    items={this._sortSelectItems}
                                />
                                <Button
                                    className="SpotListSearchControls-actions-cta SpotListSearchControls-filters"
                                    onClick={this._onFilterSpotsToggle}
                                >
                                    Filter
                                    {badgeLabel ? (
                                        <Badge className="SpotListSearchControls-filter-badge">
                                            {badgeLabel}
                                        </Badge>
                                    ) : (
                                        <IconFilter />
                                    )}
                                </Button>
                            </div>
                        </div>
                    )}
            </div>
        );
    }
}

const mapStateToProps = ({
    city: {data: city},
    destination: {data: destination},
    event: {data: event},
    filters: {numActive},
    search: {
        data: {areFiltersVisible, breadcrumbs, searchType, sortBy},
    },
    spots: {isPending: areSpotsLoading},
}) => {
    return {
        city,
        destination,
        event,
        areFiltersVisible,
        breadcrumbs,
        sortBy,
        numActiveFilters: numActive,
        isFetchComplete: !areSpotsLoading,
        searchType,
    };
};

const mapDispatchToProps = {
    onChangeSort: setSortType,
    onFilterSpotsToggle: toggleFiltersView,
    onToggleInfoPanel: toggleInfoPanelView,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SpotListSearchControls);
